export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric chars with hyphens
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
    .replace(/-+/g, '-'); // Replace multiple hyphens with single hyphen
};

export const getContentPath = (id: string, slug?: string, contentType = 'punishment'): string => {
  return contentType == 'punishment' ? `/punishments/${slug || id}` : `/draft-ideas/${slug || id}`;
  //return `/punishments/${slug || id}`;
};